<main class="template-print-page">
  @if (errorMessage) {
    <div class="print-error">{{ errorMessage }}</div>
  } @else {
    <div class="print-content">
      <div class="print-header mb-3 p-3 border-1 surface-border border-round">
        <h2 class="m-0 mb-2">{{ template.templateName }}</h2>
        <p class="text-500 m-0">{{ template.description }}</p>
      </div>

      <ng-template #printSectionTemplate let-sect="section" let-level="level">
        <div class="preview-panel preview-panel--open" [class.preview-panel--sub]="level > 0">
          <div class="preview-panel-hdr">
            <button class="preview-toggle-btn" type="button">
              <i class="ri-arrow-up-s-line"></i>
            </button>
            <div class="preview-panel-info">
              <span class="preview-panel-name">{{ sect.sectionName }}</span>
              @if (sect.description) {
                <span class="preview-panel-desc">{{ sect.description }}</span>
              }
            </div>
          </div>

          <div class="preview-panel-body">
            @for (child of getSectionChildren(sect); track $index) {
              @if (child.type === 'lineItem') {
                <div class="preview-line-item">
                  @if (asLineItem(child).controlTypeId !== undefined && asLineItem(child).controlTypeId !== null) {
                    @if (asLineItem(child).controlTypeId === ControlType.TextBox) {
                      <app-textbox-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.TextArea) {
                      <app-textarea-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.CheckBox) {
                      <app-checkbox-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Select) {
                      <app-select-control [lineItem]="asLineItem(child)"
                        [options]="asLineItem(child).lineItemOptionValueList || []" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.ImpactedArea) {
                      <app-select-control [lineItem]="asLineItem(child)"
                        [options]="asLineItem(child).lineItemOptionValueList || []" [multiple]="true" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.DatePicker) {
                      <app-datepicker-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.DateTimePicker) {
                      <app-datetimepicker-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Table) {
                      <app-table-control [lineItem]="asLineItem(child)" [projectId]="0" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Attachment) {
                      <app-attachment-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Picture) {
                      <app-picture-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Signature) {
                      <app-signature-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.DigitalSignature) {
                      <app-digitalsignature-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.QRScanner) {
                      <app-qrscanner-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Weather) {
                      <app-weather-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.RichText) {
                      <app-richtext-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.LabelText) {
                      <app-labeltext-control [lineItem]="asLineItem(child)" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Skids) {
                      <app-skids-control [lineItem]="asLineItem(child)" [projectId]="0" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Decimal) {
                      <app-decimal-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                    @if (asLineItem(child).controlTypeId === ControlType.Integer) {
                      <app-integer-control [lineItem]="asLineItem(child)" [disabled]="true" />
                    }
                  }
                </div>
              } @else {
                <ng-container *ngTemplateOutlet="printSectionTemplate; context: {section: asSubsection(child), level: level + 1}"></ng-container>
              }
            }
          </div>
        </div>
      </ng-template>

      @for (sect of sections; track $index) {
        <ng-container *ngTemplateOutlet="printSectionTemplate; context: {section: sect, level: 0}"></ng-container>
      }
    </div>
  }
</main>
